import React from 'react';
import { Link } from 'react-router-dom';

import { BiWalletAlt } from "react-icons/bi";
import { RiStackLine } from "react-icons/ri";
import { PiRocketLaunch } from "react-icons/pi";
import { CgGames } from "react-icons/cg";
import { AiOutlineAppstoreAdd } from "react-icons/ai";

const TelegramNavigation = () => {
  return (
    <div className="fixed bg-tgBackground z-50 bottom-0 left-0 right-0 shadow-md flex justify-center items-center text-center py-2 pb-4 px-10">
      <Link to='/?source=telegram' className="flex flex-col items-center px-3 text-gray-100">
        <BiWalletAlt size={20} />
        <span className="text-sm mt-1">Wallet</span>
      </Link>
      <Link to='/crypto?source=telegram' className="flex flex-col items-center px-3 text-gray-100">
        <RiStackLine size={20} />
        <span className="text-sm mt-1">Market</span>
      </Link>
      <div className="flex flex-col items-center px-3 text-gray-100">
        <PiRocketLaunch size={20} />
        <span className="text-sm mt-1">Earn</span>
      </div>
      <div className="flex flex-col items-center px-3 text-gray-100">
        <CgGames size={20} />
        <span className="text-sm mt-1">Games</span>
      </div>
      <div className="flex flex-col items-center px-3 text-gray-100">
        <AiOutlineAppstoreAdd size={20} />
        <span className="text-sm mt-1">Apps</span>
      </div>
    </div>
  );
};

export default TelegramNavigation;
